import { Stack } from '@mui/material';
import React from 'react';
import { FieldValueView } from '../../FieldValueView';
import { EditFieldButton } from '../../EditFieldButton';

interface Props {
  currentValue: number | string;
  newValue?: number | string;
  isApproximate?: boolean;
  openEditMode?: () => void;
  disabled?: boolean;
  disabledExplanation?: string;
}

export const EditableFieldValueView: React.FC<Props> = ({
  currentValue,
  newValue,
  isApproximate,
  openEditMode,
  disabled,
  disabledExplanation,
}) => {
  return (
    <Stack direction="row" alignItems="center">
      <FieldValueView
        oldValue={currentValue}
        newValue={newValue}
        hasNewValue={!!newValue && currentValue !== newValue}
        approximatelyEqual={isApproximate}
      />
      {openEditMode && (
        <EditFieldButton onEdit={openEditMode} disabled={disabled} title={disabledExplanation} />
      )}
    </Stack>
  );
};
